<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
        style="padding-top:0;margin-top:0" size="medium" label-suffix="：">
        <el-col>
          <el-form-item label="副仓" v-if="subWarehouseList && subWarehouseList.length > 1 && currentOrderFlag == 0">
            <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择" clearable multiple collapse-tags
              style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID">
            <el-input v-model="searchForm.ORDER_ID"></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model="searchForm.PRODUCT"></el-input>
          </el-form-item>
          <el-form-item label="团餐客户" v-if="currentOrderFlag == 0">
            <el-select filterable v-model="searchForm.TC_ID" @change="(e) => { __queryProjectList(e) }"
              placeholder="请选择" clearable>
              <el-option v-for="item in 团餐客户列表" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点" v-if="currentOrderFlag == 0">
            <el-select filterable v-model="searchForm.PROJECT" @change="__querydkList()" placeholder="请选择" clearable
              multiple collapse-tags>
              <el-option v-for="item in points" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口" v-if="currentOrderFlag == 0">
            <el-select filterable v-model="searchForm.dkName" placeholder="请选择档口" style="width: 100%" clearable>
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" v-else>
            <el-select v-model="searchForm.SUPPLIER" filterable placeholder="请选择" clearable>
              <el-option v-for="item in supplierList" :key="item.value" :label="item.AB_NAME"
                :value="item.SUPPLIER_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :picker-options="pickerOptions" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单状态" v-if="currentOrderFlag == 0">
            <el-select filterable v-model="searchForm.STATUS" placeholder="请选择" clearable>
              <el-option v-for="item in orderType" :key="item.value" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单类型" v-if="currentOrderFlag == 0">
            <el-select filterable v-model="searchForm.ADDED_ORDER" placeholder="请选择" clearable>
              <el-option v-for="item in addedOrderTypeList" :key="item.value" :label="item.NAME" :value="item.ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="配送类型" v-if="currentOrderFlag == 0">
            <el-select multiple filterable v-model="searchForm.DETAIL_TYPE" placeholder="请选择配送类型" clearable>
              <el-option v-for="item in 团餐客户配送类型列表" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="无实发订单">
            <el-checkbox v-model="searchForm.NEED_COUNT_CHECK"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button id="search" type="primary" @click="handleSearch" :loading="loadSearch">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="exportAllOrder" v-if="fun_dic[100060102]">导出订单</el-button>
            <el-button type="primary" plain @click="openExportOwnPrice"
              v-if="currentOrderFlag == 0 && (fun_dic[100060103] || fun_dic[100060106])">
              导出PDF
            </el-button>
            <el-button type="primary" plain @click="monthlyDeliveryRecordSummaryDialog = true"
              v-if="fun_dic[100060104]">月度送货记录汇总PDF</el-button>
            <tooltip-button :disabled="Boolean(searchForm.DAY_INTERVAL && searchForm.DAY_INTERVAL[0])"
              tipContent="请选择日期范围" buttonText="订单汇总导出" buttonType="primary" buttonPlain @click="exportSummary">
            </tooltip-button>
            <el-button @click="reNewPrice" v-show="fun_dic[100060101]">价格更新</el-button>
            <el-button type="primary" @click="dailyOrderPrinting" v-show="fun_dic[100060105]">项目点日订单打印</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-tabs type="border-card" @tab-click="handleTabClick">
        <el-tab-pane label="团餐客户订单">
          <el-col :span="24">
            <el-table :data="newOrderListData" border stripe :summary-method="getSummaries" show-summary
              style="width: 100%">
              <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
              <el-table-column prop="ORDER_ID" label="订单ID" min-width="100"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
              <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_WEIGHT" label="总重（KG）" min-width="100"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" min-width="90"></el-table-column>
              <el-table-column prop="ADDED_ORDER" label="订单类型" min-width="90"></el-table-column>
              <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出订单</el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质</el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告</el-button>
                  <el-button type="text" size="small" icon="el-icon-printer"
                    @click="previewSelf(scope.row)">自有价格打印</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="供应商客户订单">
          <el-col :span="24">
            <el-table :data="supplierCusAllData" border stripe :summary-method="getSummaries" show-summary
              style="width: 100%">
              <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
              <el-table-column prop="ORDER_ID" label="订单ID" min-width="100"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
              <el-table-column prop="SUPPLIER_CLIENT_NAME" label="客户" min-width="90"></el-table-column>
              <el-table-column prop="REAL_TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_WEIGHT" label="总重（KG）" min-width="100"></el-table-column>
              <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="supplierCusdetail(scope.row)">查看</el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出订单</el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质</el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告</el-button>
                  <el-button type="text" size="small" @click="outPutDetail(scope.row)">导出详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleSupplierChange" :current-page.sync="currentSupplierPage"
              :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="supplierTotalCount">
            </el-pagination>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-dialog title="价格更新导入" center :visible.sync="exportPrice" @close="exportPrice = false" width="500px">
      <el-form :model="exportForm" ref="exportForm" label-suffix="：">
        <el-form-item label="上传文件" :label-width="formLabelWidth">
          <el-upload :data="$uploadParams" class="upload-demo" action="/uploadFile" :on-success="handleSuccess"
            :name="this.exportForm.excel" :multiple="false" :limit="1" accept=".xls,.xlsx" :file-list="fileList">
            <el-button v-preventReClick size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
          </el-upload>
          <el-form-item>
            <span @click="downLoadAllTemp" style="color:#409EFF">点此下载导入模板</span>
          </el-form-item>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="close()">取 消</el-button>
        <el-button v-preventReClick @click="submitExport()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 自有价格打印设置 -->
    <el-dialog title="自有价格打印项" center :visible.sync="printSelfSetFormVisible" width="500px">
      <el-form label-suffix="：">
        <el-form-item label="单据类型">
          <el-radio v-model="docTypeRadioSelf" label="0">长单子</el-radio>
          <el-radio v-model="docTypeRadioSelf" label="1">短单子</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="printSelfSetFormVisible = false">取 消</el-button>
        <el-button @click="submitPrintSelf">打印</el-button>
      </div>
    </el-dialog>
    <!--   项目点日订单打印 -->
    <el-dialog title="项目点日订单打印" center :visible.sync="dailyOrderPrintingVisible" width="500px">
      <el-form :label-width="formLabelWidth" size="medium" label-suffix="：">
        <el-form-item label="日期">
          <el-date-picker v-model="dailyOrderPrintingForm.DATE" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="项目点">
          <el-select filterable v-model="dailyOrderPrintingForm.PROJECT_ID" placeholder="请选择"
            @change="updateProjectName">
            <el-option v-for="item in points" :key="item.PROJECT_ID" :label="item.PROJECT_NAME"
              :value="item.PROJECT_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实收">
          <el-radio v-model="dailyOrderPrintingForm.REAL_COUNT" label="0">不带实收</el-radio>
          <el-radio v-model="dailyOrderPrintingForm.REAL_COUNT" label="1">带实收</el-radio>
        </el-form-item>
        <el-form-item label="价格">
          <el-radio v-model="dailyOrderPrintingForm.WITH_PRICE" label="0">不带价格</el-radio>
          <el-radio v-model="dailyOrderPrintingForm.WITH_PRICE" label="1">带价格</el-radio>
        </el-form-item>
        <el-form-item label="单据类型">
          <el-radio v-model="dailyOrderPrintingForm.docTypeRadioSelf" label="0">长单子</el-radio>
          <el-radio v-model="dailyOrderPrintingForm.docTypeRadioSelf" label="1">短单子</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dailyOrderPrintingVisible = false">取 消</el-button>
        <el-button @click="submitPrintdailyOrder">打 印</el-button>
      </div>
    </el-dialog>
    <!-- 导出PDF -->
    <el-dialog title="导出PDF" center :visible.sync='exportOwnPriceVisible' width="500px">
      <el-form label-suffix="：">
        <el-form-item label="单据类型">
          <el-radio v-model="submitPrintRadioSelf" label="1">长单子</el-radio>
          <el-radio v-model="submitPrintRadioSelf" label="0">短单子</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportOwnPriceVisible = false">取 消</el-button>
        <el-button @click="exportOwnPrice">导 出</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导出月度送货记录汇总PDF" center :visible.sync="monthlyDeliveryRecordSummaryDialog" width="450px"
      :close-on-click-modal="false" @close="closeMonthlyDeliveryRecordSummaryDialog" :collapse-tags="false">
      <el-form ref="monthlyDeliveryRecordSummaryForm" :model="monthlyDeliveryRecordSummaryForm"
        :label-width="formLabelWidth" label-suffix="：">
        <el-form-item label="客户" prop="CUSTOMER_ID_LIST">
          <el-select filterable style="width: 90%" v-model="monthlyDeliveryRecordSummaryForm.CUSTOMER_ID_LIST"
            placeholder="请选择客户" multiple>
            <el-option v-for="item in customerData" :key="currentOrderFlag ? item.SUPPLIER_ID : item.TC_ID"
              :label="item.AB_NAME" :value="currentOrderFlag ? item.SUPPLIER_ID : item.TC_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月份" :label-width="formLabelWidth" prop="MONTH">
          <el-date-picker v-model="monthlyDeliveryRecordSummaryForm.MONTH" style="width: 90%" type="month" align="right"
            value-format="yyyy-MM" :clearable="false" placeholder="请选择月份">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeMonthlyDeliveryRecordSummaryDialog">取 消</el-button>
        <tooltip-button :disabled="monthlyDeliveryRecordSummaryForm.MONTH[0]" tipContent="请先选择月份" buttonType="primary"
          buttonText="确 定" @click="exportMonthlyDeliveryRecordSummary">
        </tooltip-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  allOrderDataFun, outHistoryFun, allOrderExportFun, exportCheckFun, outSelfKindOrder, selectTCFun,
} from 'api/sellOrder';
import { supplierCusFun } from 'api/customerManage';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import date from '@/assets/common/date';
import orderMixin from '@/assets/common/mixins/orderMixin.js';

export default {
  mixins: [orderMixin],
  data () {
    return {
      exportPrice: false,
      loadSearch: false,
      formLabelWidth: '120px',
      exportForm: {
        excel: 'tmp',
      },
      file_name: '',
      fileList: [],
      orderType: [
        {
          NAME: '待送订单',
          ID: 1,
        },
        {
          NAME: '待确认订单',
          ID: 4,
        },
        {
          NAME: '待供应商确认',
          ID: 6,
        },
        {
          NAME: '历史订单',
          ID: 7,
        },
      ],
      dkList: [],
      shopName: '清美',
      managername: '老张',
      团餐客户列表: [],
      companys: [
        {
          TC_ID: '',
          AB_Name: '',
        },
      ],
      points: [
        {
          PROJECT_ID: '',
          PROJECT_NAME: '',
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
      newOrderListData: JSON.parse(sessionStorage.getItem('tableData')) ? JSON.parse(sessionStorage.getItem('tableData')) : [],
      searchForm: JSON.parse(sessionStorage.getItem('searchForm')) ? JSON.parse(sessionStorage.getItem('searchForm')) : { DAY_INTERVAL: [date(new Date() - 30 * 24 * 60 * 60 * 1000, '%F'), date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000, '%F')] },
      dailyOrderPrintingForm: {
        DATE: '',
        PROJECT_ID: '',
        WITH_PRICE: '0',
        REAL_COUNT: '0',
        docTypeRadioSelf: '0',
      },
      index: 0,
      pageTitle: '全部订单列表',
      orderStatusLists: ['', '待送订单', '待确认订单', '待确认订单', '待确认订单', '待供应商确认', '历史订单'],
      printSelfSetFormVisible: false,
      dailyOrderPrintingVisible: false,
      docTypeRadioSelf: '0',
      exportOwnPriceVisible: false,
      submitPrintRadioSelf: '0',
      supplierCusAllData: [],
      currentSupplierPage: 1,
      supplierTotalCount: 0,
      currentOrderFlag: 0,
      supplierList: [],
      PAGE_ID: '1000601', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        100060101: 0, 100060102: 0, 100060103: 0, 100060104: 0, 100060105: 0, 100060106: 0,
      },
      json_meta: [[{
        key: 'charset',
        value: 'utf-8',
      }]],
      json_data: [],
      json_fields: {},
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      monthlyDeliveryRecordSummaryDialog: false,
      monthlyDeliveryRecordSummaryForm: {
        MONTH: [],
      },
      allCustomerList: JSON.parse(sessionStorage.getItem('allCustomerList')),
      团餐客户配送类型列表: this.$util.团餐客户配送类型列表,
    };
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.ALL_SEARCH_DATA_CONDITION.CONDITION) {
      this.searchForm = this.ALL_SEARCH_DATA_CONDITION.CONDITION;
      this.currentPage = this.ALL_SEARCH_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    // 获取项目点信息列表
    this.queryTitle();
    // 客户信息列表
    this.querySupplierList();
    // 团餐客户订单列表
    this.queryNewOrderListData();
    // 控制价格更新按钮
    this.queryBeforeFun();
    this.拉取团餐客户();
  },
  computed: {
    ALL_SEARCH_DATA_CONDITION () {
      return this.$store.state.ALL_SEARCH_DATA_CONDITION;
    },
    customerData () {
      return this.currentOrderFlag ? this.supplierList : this.allCustomerList;
    },
  },
  methods: {
    拉取团餐客户 () {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.团餐客户列表 = [...new Set(result[0].company.map((item) => JSON.stringify(item)))].map((item) => JSON.parse(item));
        } else {
          this.团餐客户列表 = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ------------------------------------查看
    detail (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('tableData', JSON.stringify(this.newOrderListData));
      sessionStorage.setItem('searchForm', JSON.stringify(this.searchForm));
      sessionStorage.setItem('NEED_TCNAME', row.TC_NAME);
      this.$router.push({ path: '/allOrderDetail/detail' });
    },
    orderContract (row) {
      this.$router.push({ name: 'orderContract', params: { id: row.ORDER_ID } });
      sessionStorage.setItem('pageTitle', this.pageTitle);
    },
    // -------------------------------------进入页面拉取数据
    queryNewOrderListData () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        NEED_COUNT_CHECK: this.searchForm.NEED_COUNT_CHECK ? 1 : 0,
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.STATUS) {
        params.STATUS = this.searchForm.STATUS;
      }
      if (this.searchForm.dkName) {
        params.DK_ID = this.searchForm.dkName;
      }
      if (this.searchForm.PRODUCT) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT;
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        params.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.DETAIL_TYPE && this.searchForm.DETAIL_TYPE.length) {
        params.DETAIL_TYPE = this.searchForm.DETAIL_TYPE;
      }
      this.loadSearch = true;
      allOrderDataFun(params).then((result) => {
        if (result[0]) {
          this.newOrderListData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_ALL_SEARCH_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.newOrderListData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }

        this.loadSearch = false;
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // set 项目点名称
    updateProjectName () {
      const project = this.points.find((item) => item.PROJECT_ID === this.dailyOrderPrintingForm.PROJECT_ID);
      if (project) {
        this.dailyOrderPrintingForm.PRINT_PROJECT_NAME = project.PROJECT_NAME;
        sessionStorage.setItem('PRINT_PROJECT_NAME', project.PROJECT_NAME);
      }
    },
    // ----------------------------------------获取项目点信息列表
    queryTitle () {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 18,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.points = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 项目点 日订单打印
    submitPrintdailyOrder () {
      if (!this.dailyOrderPrintingForm.DATE) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      if (!this.dailyOrderPrintingForm.PROJECT_ID) {
        this.$message.show({ text: '请选择项目点', type: 'warning' });
        return false;
      }
      this.$router.push({ path: 'dailyOrderPrinting' });
      sessionStorage.setItem('PRINT_WITH_PRICE', this.dailyOrderPrintingForm.WITH_PRICE);
      sessionStorage.setItem('PRINT_REAL_COUNT', this.dailyOrderPrintingForm.REAL_COUNT);
      sessionStorage.setItem('dailyOrderDocTypeRadioSelf', this.dailyOrderPrintingForm.docTypeRadioSelf);
      sessionStorage.setItem('PRINT_PROJECT_ID', this.dailyOrderPrintingForm.PROJECT_ID);
      sessionStorage.setItem('PRINT_DATE', this.dailyOrderPrintingForm.DATE);
    },
    __queryProjectList (e) {
      if (e == '') {
        return false;
      }
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 18,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: e,
      };
      // haveXMDFun()
      http.post(params).then((result) => {
        this.points = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------------------------下拉框获取档口名称
    __querydkList () {
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
        params.PROJECTS_ID = this.searchForm.PROJECT;
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // ---------------------------------------------导出单条订单
    output (row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: row.ORDER_ID,
          };
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          outHistoryFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // 提交导出所有订单按钮
    exportAllOrder () {
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        const params = {
          START_DAY: this.searchForm.DAY_INTERVAL[0],
          END_DAY: this.searchForm.DAY_INTERVAL[1],
        };
        if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
          params.PROJECT_ID = this.searchForm.PROJECT;
        }
        if (this.currentOrderFlag == 1) {
          params.IS_SUPPLIER_CLIENT = 1;
          params.THIRD_INFO = 1;
          if (this.searchForm.SUPPLIER) {
            params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
          }
        }
        if (this.currentOrderFlag == 0) {
          if (this.searchForm.TC_ID) params.TC_ID = this.searchForm.TC_ID;
        }
        if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
          params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
        }
        if (this.searchForm.DETAIL_TYPE && this.searchForm.DETAIL_TYPE.length) params.DETAIL_TYPE = this.searchForm.DETAIL_TYPE;

        if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) params.ADDED_ORDER = this.searchForm.ADDED_ORDER;
        allOrderExportFun(params).then((result) => {
          if (result[0]) {
            if (result[0].TASK_CREATED_SUCCESSFULLY) {
              this.$util.getUnreadInformation(this);
              this.$confirm(this.$util.appointmentMessage, '温馨提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
              }).then(() => {
                this.$router.push({ name: 'appointmentHandling' });
              }).catch(() => {
                this.$message.show({ type: 'info', text: '取消操作' });
              });
            }
            if (result[0].FILE_PATH) window.open(this.$util.getURLLocalHost(result[0].FILE_PATH));
          } else this.$message.show({ text: '无相关信息', type: 'warning' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
    },
    // 自有分类导出
    exportSMPKindOrder () {
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        const params = {
          START_DATE: this.searchForm.DAY_INTERVAL[0],
          END_DATE: this.searchForm.DAY_INTERVAL[1],
        };
        if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) params.PROJECT_ID = this.searchForm.PROJECT;
        outSelfKindOrder(params).then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请选择导出日期范围', type: 'warning' });
        return false;
      }
    },
    setAddedOrderFlag (row, flag) {
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryNewOrderListData();
    },
    // 点击筛选按钮触发
    handleSearch () {
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        if (this.currentOrderFlag == 0) {
          this.currentPage = 1;
          // 团餐客户订单列表
          this.queryNewOrderListData();
        } else if (this.currentOrderFlag == 1) {
          this.currentSupplierPage = 1;
          // 供应商客户订单列表
          this.querysupplierCusAllData();
        }
      } else {
        this.$message.show({ text: '请选择日期', type: 'warning' });
      }
    },
    exportCheck (row) {
      const params = {
        ORDER_ID: row.ORDER_ID,
      };
      if (this.currentOrderFlag == 1) params.IS_SUPPLIER_CLIENT = 1;
      exportCheckFun(params).then((result) => {
        this.$message.show({ text: '导出成功', type: 'success' });
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 自有价格打印模态框
    previewSelf (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      this.printSelfSetFormVisible = true;
    },
    // 自有价格打印
    submitPrintSelf () {
      this.$router.push({ name: 'sellOrderPrintSelf' });
      sessionStorage.setItem('countFlag', '9'); // 9表示不需要送货数量或者订购数量
      sessionStorage.setItem('isShortDocFlag', this.docTypeRadioSelf);
      sessionStorage.setItem('printRealFlag', '1'); // 自有订单需要打印实收数量
    },
    handleTabClick (tab, event) {
      this.currentOrderFlag = Number(tab.index);
      if (this.currentOrderFlag == 0) {
        this.currentPage = 1;
        // 团餐客户订单列表
        this.queryNewOrderListData();
      } else if (this.currentOrderFlag == 1) {
        this.currentSupplierPage = 1;
        // 供应商客户订单列表
        this.querysupplierCusAllData();
      }
    },
    // 价格更新导入模态框判断
    openExportOwnPrice () {
      if (this.searchForm.DAY_INTERVAL === null || this.searchForm.DAY_INTERVAL.length == 0) this.$message.show({ text: '请选择日期范围', type: 'warning' });
      else this.exportOwnPriceVisible = true;
    },
    // 项目点日订单打印
    dailyOrderPrinting () {
      this.dailyOrderPrintingVisible = true;
    },
    reNewPrice () {
      if (this.searchForm.DAY_INTERVAL) {
        // 关账限制
        if (this.$util.isOrderClosedRange(this.searchForm.DAY_INTERVAL)) {
          this.$message.show({ text: '日期范围内存在已关账月份，无法对已关账月份内订单进行操作', type: 'warning' });
          return false;
        }

        this.exportPrice = true;
      } else this.$message.show({ text: '请选择日期范围', type: 'warning' });
    },
    handleSuccess (response, file, fileList) {
      this.file_name = response.file_name;
    },
    // 价格更新模态框关闭
    close () {
      this.exportPrice = false;
    },
    downLoadAllTemp () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/exportPrice.xls';
    },
    // 价格跟新模态框确定提交
    submitExport () {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 35,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.DAY_INTERVAL[0],
        END_DAY: this.searchForm.DAY_INTERVAL[1],
        FILE_NAME: this.file_name,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '导入成功', type: 'success' });
        this.exportPrice = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 获取供应商用户信息列表
    querysupplierCusAllData () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentSupplierPage - 1,
        IS_SUPPLIER_CLIENT: 1,
        NEED_COUNT_CHECK: this.searchForm.NEED_COUNT_CHECK ? 1 : 0,
      };
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
      }
      if (this.searchForm.STATUS) {
        params.STATUS = this.searchForm.STATUS;
      }
      if (this.searchForm.DAY_INTERVAL != null || this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.PRODUCT) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT;
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      allOrderDataFun(params).then((result) => {
        if (result[0]) {
          this.supplierCusAllData = result[0].list;
          this.supplierTotalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_ALL_SEARCH_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.supplierCusAllData = [];
          this.supplierTotalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },

    // 供应商用户查看详情
    supplierCusdetail (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('TEM_ISSUPPLIER', 0);
      this.$router.push({ path: '/supplierCusAllOrderDetail/detail' });
    },
    handleSupplierChange (e) {
      this.currentSupplierPage = e;
      this.querysupplierCusAllData();
    },
    querySupplierList () {
      const params = {};
      supplierCusFun(params).then((res) => {
        if (res.length !== 0) {
          this.supplierList = res[0].list;
        } else {
          this.supplierList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 自有价格导出PDF
    exportOwnPrice () {
      const params = {
        SERVICE_ID: '10042',
        OTYPE: 27,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.DAY_INTERVAL[0],
        END_DAY: this.searchForm.DAY_INTERVAL[1],
        PRINT_TYPE: Number(this.submitPrintRadioSelf),
        IS_BJKKL: Number(this.fun_dic[100060106]),
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
        params.PROJECTS_ID = this.searchForm.PROJECT.join(',');
      }
      if (this.searchForm.STATUS) {
        params.STATUS = this.searchForm.STATUS;
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        params.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.$message.show({ text: '导出成功', type: 'success' });
        this.exportOwnPriceVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 全部订单导出前的数据查询
    async startDownload () {
      if (Array.isArray(this.searchForm.DAY_INTERVAL)) {
        if (this.searchForm.DAY_INTERVAL.length == 0) {
          this.$message.show({ text: '请选择日期范围', type: 'error' });
          return false;
        }
      } else if (!this.searchForm.DAY_INTERVA) {
        this.$message.show({ text: '请选择日期范围', type: 'error' });
        return false;
      }
      const params = {
        START_DAY: this.searchForm.DAY_INTERVAL[0],
        END_DAY: this.searchForm.DAY_INTERVAL[1],
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
        if (this.searchForm.SUPPLIER) {
          params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
        }
      }
      await allOrderExportFun(params).then((result) => {
        if (result.ansData.length > 0) {
          this.json_data = result.ansData;
          if (result.iIsShortName == 1) {
            this.json_fields = {
              团餐公司: 'TC_NAME',
              日期: 'SEND_DAY',
              订单ID: 'ORDER_ID',
              订单编号: 'ORDER_CODE',
              供应商: 'SUPPLIER_NAME',
              工商编码: 'TAX_CODE',
              项目点: 'PROJECT_NAME',
              项目点编码: 'PROJECT_ID',
              档口: 'DK_NAME',
              大类: 'FCNAME',
              二类: 'SCNAME',
              单品: 'SHORT_NAME',
              单品编码: { field: 'PRODUCT_CODE', callback: (value) => `&nbsp;${value}` },
              品牌: 'BRAND',
              规格: 'SPECIFICATION',
              单位: 'TYPE_UNIT',
              销售价: 'REAL_PRICE',
              订购数量: 'PRODUCT_COUNT',
              实收数量: 'REAL_COUNT',
              销售总金额: 'SUPPLIER_FEE',
              退货数量: 'RETURN_COUNT',
              退货金额: 'RETURN_FEE',
              退货原因: 'REASON',
              订单状态: 'STATUS',
              备注: 'PRODUCT_COMMENT',
              订单备注: 'ORDER_COMMENT',
            };
          } else {
            this.json_fields = {
              团餐公司: 'TC_NAME',
              日期: 'SEND_DAY',
              订单ID: 'ORDER_ID',
              订单编号: 'ORDER_CODE',
              供应商: 'SUPPLIER_NAME',
              工商编码: 'TAX_CODE',
              项目点: 'PROJECT_NAME',
              项目点编码: 'PROJECT_ID',
              档口: 'DK_NAME',
              大类: 'FCNAME',
              二类: 'SCNAME',
              单品: 'NAME',
              单品编码: { field: 'PRODUCT_CODE', callback: (value) => `&nbsp;${value}` },
              单位: 'TYPE_UNIT',
              销售价: 'REAL_PRICE',
              订购数量: 'PRODUCT_COUNT',
              实收数量: 'REAL_COUNT',
              销售总金额: 'SUPPLIER_FEE',
              退货数量: 'RETURN_COUNT',
              退货金额: 'RETURN_FEE',
              退货原因: 'REASON',
              订单状态: 'STATUS',
              备注: 'PRODUCT_COMMENT',
              订单备注: 'ORDER_COMMENT',
            };
          }
          if (this.currentOrderFlag == 1) {
            this.json_fields['团餐公司'] = 'SUPPLIER_CLIENT_NAME';
          }
          this.$message.show({ text: '导出成功', type: 'success' });
        } else {
          this.json_data = [];
          this.$message.show({ text: '暂无数据', type: 'error' });
          return false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    endDonload () {
      this.json_data = [];
    },
    // 单元格合计
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'REAL_TOTAL_SUPPLIER_FEE' || column.property === 'REAL_TOTAL_WEIGHT') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + Math.floor((value) * 100) / 100;
            }
            return prev;
          }, 0).toFixed(2);
        }
      });
      this.sums = sums;
      return sums;
    },
    exportMonthlyDeliveryRecordSummary () {
      if (!this.monthlyDeliveryRecordSummaryForm.MONTH) {
        this.$message.show({ text: '请选择月份', type: 'warning' });
        return;
      }
      const params = this.currentOrderFlag ? {
        SERVICE_ID: '15069',
        OTYPE: 8,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        MONTH: this.monthlyDeliveryRecordSummaryForm.MONTH,
      } : {
        SERVICE_ID: '15069',
        OTYPE: 9,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        MONTH: this.monthlyDeliveryRecordSummaryForm.MONTH,
      };
      if (this.monthlyDeliveryRecordSummaryForm.CUSTOMER_ID_LIST && this.monthlyDeliveryRecordSummaryForm.CUSTOMER_ID_LIST[0]) {
        params[this.currentOrderFlag ? 'GYS_ID_LIST' : 'TC_ID_LIST'] = this.monthlyDeliveryRecordSummaryForm.CUSTOMER_ID_LIST;
      }
      http.post(params).then((res) => {
        if (res[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        }
        if (res[0].TASK_CREATED_SUCCESSFULLY) {
          this.$util.getUnreadInformation(this);
          this.$confirm(this.$util.appointmentMessage, '温馨提示', {
            confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
          }).then(() => {
            this.$router.push({ name: 'appointmentHandling' });
          }).catch(() => {
            this.$message.show({ type: 'info', text: '取消操作' });
          });
        }
        this.closeMonthlyDeliveryRecordSummaryDialog();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    closeMonthlyDeliveryRecordSummaryDialog () {
      this.monthlyDeliveryRecordSummaryDialog = false;
      this.$refs.monthlyDeliveryRecordSummaryForm.resetFields();
    },
    exportSummary () {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 18,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.DAY_INTERVAL[0],
        END_DAY: this.searchForm.DAY_INTERVAL[1],
      };
      http.post(params).then((res) => {
        if (res[0] && res[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 导出详情
    outPutDetail (row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '15064',
            OTYPE: 2,
            PURCHASE_ORDER_ID: row.ORDER_ID,
          };
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {

        }
      }
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/AllOrderList.vue